module.exports = __webpack_public_path__ + "static/img/比价@3x.e8cf86e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/比价@3x.png
// module id = DH/B
// module chunks = 192